var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiUrls } from "../../../../example1/login/api_test/configuration";
import PaperHubClientEmulator from "../../../../example1/paper_hub_emulator/PaperHubClientEmulator";
/**
 * authentification이 필요 없는 legacy paper 첨부 파일
 * 공책 배경 정보를 PaperHub에서 가져온 것 처럼 emulation
 *
 * @param {number} paperGroupId
 * @param {{ id: number, tag: string }} attachment
 * @param {IPageSOBP} sobp
 * @return {*}
 */
export function getLegacyAttachment(paperGroupId, attachment, sobp) {
    return __awaiter(this, void 0, void 0, function* () {
        let ret = null;
        const key = `${sobp.section}.${sobp.owner}.${sobp.book}`;
        // TODO: PaperHub를 쓰도록 변경해야 한다. 2021/07/06
        const pi = PaperHubClientEmulator.getInstance();
        const found = pi.getPaperDefinition(sobp);
        console.log(attachment.tag);
        if (found) {
            console.log(attachment.tag, "found");
            const nprojUrl = makeLegacyResourceUrl(found.nproj_file + ".gz");
            switch (attachment.tag) {
                case "background_image_all": {
                    const pi = PaperHubClientEmulator.getInstance();
                    const registerItem = yield pi.retreivePaperInfo(sobp);
                    if (registerItem) {
                        ret = {
                            "id": attachment.id,
                            "paperGroupId": paperGroupId,
                            "originalName": registerItem.filename,
                            "mimeType": "application/pdf",
                            "tag": "background/pdf",
                            "status": "ENABLE",
                            "size": undefined,
                            "downloadUri": registerItem.pdf_url_from_paperhub,
                            "createdAt": "2021-06-23T06:30:51.188Z",
                            "modifiedAt": "2021-06-23T06:30:51.188Z", // "2021-06-23T06:30:51.188Z"
                        };
                    }
                    break;
                }
                case "thumbnail_image": {
                    break;
                }
                case "nproj": {
                    ret = {
                        "id": attachment.id,
                        "paperGroupId": paperGroupId,
                        "originalName": found.nproj_file,
                        "mimeType": "application/pdf",
                        "tag": "background/xml",
                        "status": "ENABLE",
                        "size": undefined,
                        "downloadUri": nprojUrl,
                        "createdAt": "2021-06-23T06:30:51.188Z",
                        "modifiedAt": "2021-06-23T06:30:51.188Z", // "2021-06-23T06:30:51.188Z"
                    };
                    break;
                }
                case "cover_image": {
                    break;
                }
            }
        }
        return ret;
    });
}
export const makeLegacyResourceUrl = (filename) => {
    // 이전에는 아래와 같이. 2021/06/13
    // return `./nbs/${filename}`;
    return apiUrls.NBS_BASE_URL + filename;
};
export const makeLegacyPdfUrl = (filename, nproj_url) => {
    // NBS 폴더의 파일이름에 버그가 있어서 다음과 같이 표기한다. 2021/06/13
    const extPos = nproj_url.indexOf(".nproj");
    const pdfUrl = nproj_url.substr(0, extPos);
    return pdfUrl + ".pdf";
    // 원래는 아래와 같이. 2021/06/13
    // return `./nbs/${filename}`;
};
//# sourceMappingURL=getLegacyAttachment.js.map